import React, { Component } from 'react';
import {connect} from "react-redux";

import store from '../../store/configureStore';
import { addNotification } from "../../actions/notificationAction";
import { lang } from '../../config/lang';
import contactApi from '../../api/contactApi';
import ContactBlock from './ContactBlock';

/****************************************
    Component for Contact Footer
    @author  IMH003
    @date    2020.05.27
    @version 0.1    
 ******************************************/
class ContactFooter extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            arrContact: []
        }
        this.getContacts = this.getContacts.bind(this);
    }

    componentWillMount() {
        
    }

    componentDidMount() {
        this.getContacts();
    }
  
    componentWillUnmount() {

    }

    componentWillReceiveProps(newProps) {
        if (this.props.language.lang_key !== newProps.language.lang_key) {
            this.getContacts();
        }
    }

    getContacts() {
        
        contactApi.getContact().then((json) => {
            if (json.status === 200 && json.data) { 
                this.setState({
                    arrContact: json.data
                })  
                window.initContactSlider();
            } else if (json.status !== 200){                
                store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
            }            
        })
        
    }

    render() {

        if (this.state.arrContact.length === 0) {
            return (
                <div></div>
            );
        }
        return (
            <div className="footer contact-office" id="contact-section">
                <div className="container" style={{left:'25px'}}>
                    <div className="row">
                        <div className="contact-slide owl-carousel">
                            {
                                this.state.arrContact.map((contact, key) => (
                                    <ContactBlock
                                        key   = {key}
                                        title = {contact.title}
                                        phone = {contact.phone}
                                        email = {contact.email}
                                        fax   = {contact.fax}
                                    />
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(ContactFooter);